import { Box, Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

interface IContainer {
  gap?: string;
}

export const Container = styled("div")(({ gap }: IContainer) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  gap: gap ?? "16px",
}));

export const FileInputBox = styled(Grid)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  width: "100%",
  height: 250,
  border: `1px dashed ${colors.gray300}`,
  borderRadius: "4px",
  position: "relative",
  overflow: "hidden",

  "& span:nth-of-type(1)": {
    color: colors.gray600,
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "24px",
    letterSpacing: "0.1px",
  },
  "& label > span:nth-of-type(2)": {
    color: colors.gray600,
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20x",
    letterSpacing: "0.25px",
  },
  "& label > span:nth-of-type(3)": {
    color: colors.gray600,
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20x",
    letterSpacing: "0.25px",
  },
}));

export const LabelText = styled("div", { name: "LabelText" })(() => ({
  color: colors.gray600,
  fontFamily: "Manrope !important",
  fontWeight: 600,
  fontSize: "16px",
  fontHeight: "24px",
  letterSpacing: "0.15px",
  marginBottom: 0,
}));

export const FileInputText = styled(Typography)(() => ({
  textAlign: "center",
  color: "#465869",
  fontFamily: "Manrope !important",
  fontWeight: 600,
  fontSize: "18px",
  marginBottom: 0,
}));

export const FileInputSubText = styled(Typography)(() => ({
  textAlign: "center",
  color: "#667085",
  fontFamily: "Manrope !important",
  fontWeight: 400,
  fontSize: "14px",
  marginBottom: 0,
}));

export const ImageBox = styled(Box)(() => ({
  maxHeight: "250px",
  maxWidth: "210px",
  overflow: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const LabelImage = styled("label")(() => ({
  cursor: "pointer",
}));

export const ImageSelected = styled("img")(() => ({
  width: "100%",
  height: "100%",
  objectFit: "cover",
}));

export const InputImage = styled("input")(() => ({
  display: "none",
}));

export const ButtonWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 24,
  justifyContent: "center",
  marginTop: 24,
  "& > input": {
    display: "none",
  },
}));
